import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useUserAuth } from "../context/UserAuthContext";
import Logo from '../images/school_logo.png';
import Back from '../images/back3.webp';
import '../styles/Login.css';
import Loader from "./Loader";
import SuccessModal from './SuccessModal';

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const [signingIn, setSigningIn] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const { logIn } = useUserAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const loadImage = (src) => {
      return new Promise((resolve) => {
        const img = new Image();
        img.src = src;
        img.onload = resolve;
      });
    };

    loadImage(Back).then(() => setLoading(false));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSigningIn(true);
    try {
      await logIn(email, password);
      setSigningIn(false);
      navigate("/home");
    } catch (err) {
      setSigningIn(false);
      setError("Invalid email or password");
      setShowModal(true);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  if (loading) {
    return <Loader text={"LOADING"}/>;
  }

  return (
    <>
      {signingIn && <Loader text={"AUTHENTICATING"}/>}
      <div className="top-elements row align-center space-between">
        <Link to="/" className="back-link"><i className="fa-solid fa-arrow-left size3"></i></Link>      
        <div className="column align-center justify-center">           
          <img src={Logo} className="middle-logo" alt="logo" />          
        </div>
        <Link to="#" className="home-link" onClick={() => window.location.reload()}><i className="fa-solid fa-rotate-right size4"></i></Link>
      </div>
      <div className="login-page-items column align-center" style={{backgroundImage: `url(${Back})`}}>
        <div className="form-items">          
          <p className="login-heading size3 align-center justify-center">SIGN IN</p>
          <form onSubmit={handleSubmit}>
            <input
              type="email"
              id="login-email"
              className="input-field"
              placeholder="Email"
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <div style={{ position: 'relative', display: 'inline' }}>
              <input
                type={showPassword ? 'text' : 'password'}
                id="login-password"
                className="input-field"
                placeholder="Password"
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <span
                onClick={togglePasswordVisibility}
                style={{
                  position: 'absolute',
                  right: '16px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  cursor: 'pointer',
                  userSelect: 'none'
                }}
              >
                <i className={showPassword ? `fa-solid fa-eye-slash` : `fa-solid fa-eye`}></i>
              </span>
            </div>
            <div className="row align-center justify-center">
              <button type="Submit" className="login-button">
                SIGN IN
              </button>
              <Link to="/forgot-password" className="forgot-password row align-center justify-center size5">PASSWORD?</Link>
            </div>
            <div className="row align-center justify-center">
              <Link to="/student-login" className="login-button cbt-login-button align-center justify-center size5">STUDENT</Link>
            </div>
          </form>
        </div>
      </div>
      {showModal && 
        <SuccessModal
          icon="xmark"
          iconColor="red"
          message={error}
          onClose={() => {
            setError("");
            setShowModal(false);
          }}
        />
      }
    </>
  );
};

export default Login;
